/*
 * @Author: edvardchen
 * @Date:   2016-11-10 11:59:37
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 17:32:47
 */
import React from 'react';
import PropTypes from 'prop-types';

import _ from 'lodash';
// import autobind from 'core-decorators/lib/autobind';
import createRouteProxy from '../../HOCs/withRoute';
import withShareContextForShare from '../../HOCs/withShareContextForShare'; // 分享框架页面单独抽离出来组件
import Article from '../../components/Share/ArticleContainer';
// import ShareBar from '../components/Share/ShareBarContainer';
import CommentContainer from '../../components/Share/CommentContainer';
import RecommListContainer from '../../components/Share/RecommListContainer';
// import Tags from '../components/Share/ArticleTagsContainer';
// import Bottom from '../components/Share/Bottom';
import ShareUserInfo from '../../components/Share/ShareUserInfo';
import KuaibaoBanner from '../../components/Share/KuaibaoBanner';

import {
  getPageConfigData,
  dmpDataReport,
  getBackPageUrl,
  initLocationBackPage,
  isLoadKuaiBao,
} from '../../utility/PageConfigDataForShare';
import { localStorage, track, uniqueComment, isomorphicConfig, beaconReport } from '../../utility';

// import {
//   install,
//   openQb,
// } from '../utility/QBDownload';

import { article as articleService, circle } from '../../fetchers';
import urlUtil from '../../utility/url';
import { isAndroid } from '../../utility/UA';
import './index.scss';
const createContainer = require('../../externals/react-transmit/createContainer');

const addJs = async () => {
  // 灯塔上报逻辑代码
  const dynamicClass = await import(/* webpackChunkName: "dynamicAddJS" */ '../../client/dynamicAddJS');
  dynamicClass && dynamicClass.default && dynamicClass.default();
};
// import {
//   shouldContainerUpdate
// } from '../utility';

const configType = ['article', 'float_video', 'ugc_video']; // sharepageType 0-图文 1-短视频 2-小视频
@withShareContextForShare
class ShareArticleRoute extends React.PureComponent {
  static propTypes = {
    article: PropTypes.object,
    variables: PropTypes.object,
    // QBInstalled: React.PropTypes.bool,
    postInfo: PropTypes.object,
    // tags: React.PropTypes.array,
    recommList: PropTypes.array,
    shareUser: PropTypes.object,
    exposureSharelp: PropTypes.object,
    getShareNewsLandPages: PropTypes.array,
    dispatch: PropTypes.func,
  };

  recommListMore = [];
  shareUserClick = () => {
    track({
      location: 'sharelp',
      action: 'click',
      object: 'sharelp_host',
      id: this.props.exposureSharelp && this.props.exposureSharelp.docId,
      ch: this.props.exposureSharelp && this.props.exposureSharelp.ch,
    });
    // window.alert('this.context=',this.context,"guid=",cookies.get('qb_guid'),"c_sa=",cookies.get('c_sa'),"c_user=",cookies.get('c_user'),"uin=",cookies.get('uin'),"wxopenid=",cookies.get('wxopenid'));

    const ch = this.context.currentChannel || (this.props.exposureSharelp && this.props.exposureSharelp.ch);
    const shareUser = this.props.shareUser || null;
    let rediretUrl = `${window.location.origin}/feeds?ch=${ch}`;
    if (shareUser && shareUser.actType && shareUser.sId) {
      rediretUrl = `https://quan.qq.com/userCenter/${shareUser.actType}_${shareUser.sId}`;
    }
    this.context.downloadOrOpenQb({
      url: rediretUrl,
      label: 'shareuser_top',
      hideMaskModal: true,
    });
  };
  getQueryString = (name) => {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const r = window.location.search.substr(1).match(reg);
    if (r !== null) return unescape(r[2]);
    return null;
  };

  componentDidMount() {
    addJs();
    this.doCommentShareReport();
    const {
      article: { docId },
    } = this.props;
    beaconReport({
      key: 'News_Share_PV',
      params: {
        docId,
      },
    });
    const shId = this.getQueryString('sh_sid');
    if (shId && shId.indexOf('__') !== -1) {
      const sType = shId.split('__')[0];
      const sId = shId.split('__')[1];
      const { article: { subjectId } = {} } = this.props;
      this.context.addSharePower({ sType, sId, subjectId });
      this.shareUserUrlLog();
    }

    this.context.checkAndroidQB((ret) => {
      !ret &&
        track({
          location: 'sharelp',
          action: 'exposure',
          object: 'sharelp_phonenoQB',
          id: (this.props.article && this.props.article.docId) || '',
        });
    });

    const shareCount = (this.props.variables && this.props.variables.share_count) || '';
    if (shareCount) {
      track({
        location: 'sharelp',
        action: 'exposure',
        object: 'sharelp_shareCount',
        id: (this.props.article && this.props.article.docId) || '',
        ext: shareCount,
      });
    }
    if (isAndroid(window.navigator.userAgent) && /source=baipai/.test(window.location.href)) {
      track({
        location: 'sharelp',
        action: 'exposure',
        object: 'sharelp_baipai',
      });
    }
    getPageConfigData()
      .then((res) => {
        if (res.code === 0) {
          const pageConfigData = res.data || null;
          localStorage.setItem('pageConfigData', pageConfigData);

          if (pageConfigData) {
            // 如果有匹配实验规则，就上报曝光
            dmpDataReport({
              action: 'exp',
              profileId: pageConfigData.profileId,
            });

            // android端-快报-实验配置返回键中间页
            const url = getBackPageUrl();
            const isKb = isLoadKuaiBao();
            if (url && isKb && isAndroid(window.navigator.userAgent)) {
              initLocationBackPage(url);
            }

            // 如果有匹配实验规则，就上报曝光
            track({
              location: 'sharelp',
              action: 'exposure',
              object: 'sharelp_gsp_exposed',
              ch: pageConfigData.profileId,
            });
          }
        }
      })
      .catch(() => {});
  }

  doCommentShareReport() {
    const location = urlUtil.parse(window.location.href);
    const {
      query: { anchorId = '' },
    } = location;

    if (anchorId) {
      track({
        location: 'share_article',
        action: 'exposure',
        object: 'comment_card',
        id: (this.props.article && this.props.article.docId) || '',
      });
    }
  }

  shareUserUrlLog() {
    track({
      location: 'sharelp',
      action: 'exposure',
      object: 'sharelp_host_url',
      id: (this.props.article && this.props.article.docId) || '',
    });
  }

  render() {
    const {
      // tags,
      recommList,
      postInfo,
      shareUser,
      exposureSharelp,
      getShareNewsLandPages,
    } = this.props;
    let getShareNewsLandPages2 = getShareNewsLandPages;
    // console.log('recommList===', recommList);
    // console.log('getShareNewsLandPages===', getShareNewsLandPages);

    if (shareUser) {
      shareUser.onClick = this.shareUserClick;
    }

    let recommListAry = [];
    let bottomTipsAry = [];
    if (recommList && recommList instanceof Array && recommList.length > 0) {
      const hotAry = [];
      const relateAry = [];
      recommList.map((item) => {
        if (item.fromType === 'hot') {
          hotAry.push(item);
        } else if (item.fromType === 'relate') {
          relateAry.push(item);
        }
        return null;
      });
      // ABB(一条相关两条热点)
      bottomTipsAry = (relateAry.length > 0 ? relateAry.splice(0, 1) : []).concat(
        hotAry.length > 2 ? hotAry.splice(0, 2) : hotAry.splice(0, hotAry.length),
      );
      // A1(B1B2)(A4A5<补位>)
      // bottomTipsAry = bottomTipsAry.concat(relateAry.length > 3 ? relateAry.splice(2, 2) : relateAry.length > 2 ? relateAry.splice(2, 1) : []);
      let tempAry = [];
      if (relateAry.length > 3) {
        tempAry = relateAry.splice(2, 2);
      } else if (relateAry.length > 2) {
        tempAry = relateAry.splice(2, 1);
      }
      bottomTipsAry = bottomTipsAry.concat(tempAry);

      // AA^BB(一条相关两条热点)
      recommListAry = (relateAry.length > 2 ? relateAry.splice(0, 2) : relateAry.splice(0, relateAry.length)).concat(
        hotAry.length > 3 ? hotAry.splice(0, 3) : hotAry.splice(0, hotAry.length),
      );

      // A2A3(B3B4B5)(A6A7A8<补位>)
      // recommListAry = recommListAry.concat(relateAry);

      bottomTipsAry =
        bottomTipsAry.length > 3 ? bottomTipsAry.splice(0, 3) : bottomTipsAry.splice(0, bottomTipsAry.length);

      recommListAry =
        recommListAry.length > 5 ? recommListAry.splice(0, 5) : recommListAry.splice(0, recommListAry.length);
      this.recommListMore = [...hotAry, ...relateAry];
    }
    let configList = [];
    if (getShareNewsLandPages2 && getShareNewsLandPages2 instanceof Array && getShareNewsLandPages2.length > 0) {
      // const reLen = recommListAry.length;
      // if (reLen > 2) { // if第一屏大于2条配置就插入第二条后，else就直接添加在第一屏列表最后面
      //   recommListAry.splice(2, 0, ...getShareNewsLandPages);
      // } else {
      //   recommListAry.splice(reLen, 0, ...getShareNewsLandPages);
      // }
      // 位置改为由配置人员决定 position, 而且ugc这种小视频是2个为一组,下面就是相应的位置结构逻辑
      const ugcVideo = [];
      let Pair = [];
      getShareNewsLandPages2 = getShareNewsLandPages2.sort((a, b) => a.position - b.position);
      for (let i = 0; i < getShareNewsLandPages2.length; i++) {
        if (getShareNewsLandPages2[i].type === configType[2]) {
          ugcVideo.push(getShareNewsLandPages2[i]);
        } else {
          configList.push(getShareNewsLandPages2[i]);
        }
      }
      ugcVideo.map((item, key) => {
        Pair = key % 2 === 0 ? [] : Pair;
        Pair.push(item);
        if (Pair.length === 2) {
          configList.push({
            url: '',
            title: '',
            from: '',
            thumbs: '',
            labels: [],
            time: 0,
            lazyImage: true,
            type: configType[2],
            fromType: 'configure',
            listData: Pair,
            position: Pair[0].position,
          });
        }
        return item;
      });
    }
    recommListAry = recommListAry.concat(this.recommListMore);
    configList = configList.sort((a, b) => a.position - b.position);
    let realPosition = 0;
    for (let k = 0; k < configList.length; k++) {
      if (configList[k].position < recommListAry.length) {
        realPosition = k > 0 && realPosition >= configList[k].position ? realPosition + 1 : configList[k].position;
        recommListAry.splice(realPosition, 0, configList[k]);
      } else {
        recommListAry.splice(recommListAry.length, 0, configList[k]);
      }
    }

    const kuaibaoBannerStartTime = _.get(isomorphicConfig, 'kuaibaoBanner.startTime', '');
    const kuaibaoBannerEndTime = _.get(isomorphicConfig, 'kuaibaoBanner.endTime', '');
    const kuaibaoBannerImage = _.get(isomorphicConfig, 'kuaibaoBanner.image', '');

    console.log(
      'kuaibaoBannerStartTime',
      kuaibaoBannerStartTime,
      'kuaibaoBannerEndTime',
      kuaibaoBannerEndTime,
      'kuaibaoBannerImage',
      kuaibaoBannerImage,
    );

    let isBegin = false;
    if (kuaibaoBannerStartTime && kuaibaoBannerEndTime) {
      const nowTime = new Date().getTime();
      const startTime = new Date(kuaibaoBannerStartTime).getTime();
      const endTime = new Date(kuaibaoBannerEndTime).getTime();
      if (startTime <= nowTime && endTime >= nowTime) {
        isBegin = true;
      }
    }
    const klass = `mod-news-article with-toolbar G-landspace grayPage`;
    return (
      <div className={klass}>
        {shareUser && <ShareUserInfo {...shareUser} />}
        <div className="item article">
          <Article {...this.props} isShareUser={!!shareUser} />
        </div>
        {/* {tags &&
          <Tags tags={tags} />
        } */}
        {postInfo && (
          <CommentContainer dispatch={this.props.dispatch} postInfo={postInfo} exposureSharelp={exposureSharelp} />
        )}

        {isBegin && (
          <KuaibaoBanner exposureSharelp={exposureSharelp} kuaibaoBannerImage={kuaibaoBannerImage}></KuaibaoBanner>
        )}

        {recommList && (
          <RecommListContainer items={recommListAry} bottomTips={bottomTipsAry} exposureSharelp={exposureSharelp} />
        )}
      </div>
    );
  }
}

const COMMENT_LIMIT = 2;
const SHARE_RECOMM_LIST = 200;
const container = createContainer(ShareArticleRoute, {
  initialVariables: {},

  fragments: {
    article: ({ docId, url, ...args }) =>
      articleService.getContentAndBrief({
        docId,
        url,
        ...args,
        apn: 'wifi', // 分享场景统一是wifi
      }),

    postInfo: ({ docId, tagId, tabId }) => () =>
      circle.getArticlePostInfo({ docId, tagId, tabId }).then(
        (postInfo) => {
          const hot = circle
            .getHotComment({
              postId: postInfo.postId,
              circleId: postInfo.circleId,
            })
            .catch(() => []);

          const arr = [hot];
          const location = urlUtil.parse(window.location.href);
          const {
            query: { anchorId = '' },
          } = location;

          if (anchorId) {
            const anchor = circle
              .getAnchorComment({
                postId: postInfo.postId,
                anchorId,
              })
              .catch(() => {});
            arr.push(anchor);
          }

          return Promise.all(arr).then((data) => {
            const hotItmes = (data && data[0]) || [];
            const anchorItems = (data && data[1] && data[1].items && data[1].items[0] && [data[1].items[0]]) || [];
            const items = uniqueComment([].concat(anchorItems, hotItmes));

            return Object.assign(postInfo, {
              items: items
                .slice(0, COMMENT_LIMIT)
                .map((it) => Object.assign({ postId: postInfo.postId }, it, { hasOptions: false })),
            });
          });
        },
        () => {},
      ),

    // tags: ({ docId, ch }) =>
    //   () => articleService.getArticleTags({ docId, ch })
    //     .catch(e => ([])),

    recommList: ({ docId, url }) => () =>
      articleService
        .getRecommForShare({ docId, url, limit: SHARE_RECOMM_LIST })
        .then((list) => list.map((item) => Object.assign(item, { lazyImage: true })))
        .catch(() => []), // always resolve

    shareUser: ({ ...args }) => () => {
      if (args && args.sh_sid && !args.share_count) {
        const shareParms = args.sh_sid.split('__');
        const actType = shareParms[0] || 0;
        const sId = shareParms.length > 0 ? shareParms[1] : shareParms[0];
        const guid = shareParms.length > 1 ? shareParms[2] : '';

        if (actType === -1 || actType === '-1' || !sId || sId === 'undefined') {
          return new Promise((resolve) => {
            resolve();
          });
        }
        return circle
          .getSharePageUserInfo({ actType, sId, guid })
          .then((data) => {
            console.log('getSharePageUserInfo data = ', data);
            const retObj = {};
            if (data && data.userInfo) {
              retObj.faceIcon = data.userInfo.sFaceIcon;
              retObj.nickName = data.userInfo.sNickname;
            } else {
              return null;
            }
            retObj.dayNum = data.usedDay || 0;
            if (retObj.dayNum > 4000 || retObj.faceIcon === 'https://res.imtt.qq.com/tagapp/misc/default_avatar.png') {
              return null;
            }
            retObj.actType = actType;
            retObj.sId = sId;
            track({
              // 获取分享信息成功统计
              location: 'sharelp',
              action: 'exposure',
              object: 'sharelp_host',
            });
            return retObj;
          })
          .catch(() => {
            track({
              // 获取分享信息失败统计
              location: 'sharelp',
              action: 'exposure',
              object: 'sharelp_nohost',
            });
            return null;
          });
      }
      return new Promise((resolve) => {
        resolve();
      });
    },
    exposureSharelp: ({ docId, ...args }) => () => {
      track({
        location: 'sharelp',
        action: 'exposure',
        object: 'sharelp',
        id: docId,
        ch: args && args.ch,
      });
      return new Promise((resolve) => {
        resolve({ docId, ch: args && args.ch });
      }).then((message) => {
        console.log(message);
        return message;
      });
    },

    getShareNewsLandPages: () => () =>
      circle
        .getShareNewsLandPages()
        .then((data) => {
          console.log('getShareNewsLandPages data = ', data);
          const retObj = [];
          if (data && data.items) {
            data.items.map((item) => {
              const type = configType[item.sharepageType] || 'article';
              retObj.push({
                url: item.url,
                title: item.title,
                from: item.source,
                thumbs: item.imgs,
                labels: [],
                time: 0,
                lazyImage: true,
                type,
                fromType: 'configure',
                position: item.position,
              });
              return item;
            });
          }
          return retObj;
        })
        .catch(() => []),
  },
});

export default createRouteProxy(container);
